"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// https://www.npmjs.com/package/koa-normalize-path 참조
var path_1 = require("path");
var httpStatus_1 = require("./httpStatus");
var normalizePath = function (opts) {
    opts = opts || {};
    if (opts.defer !== false) {
        opts.defer = opts.defer || true;
    }
    if (opts.chained !== false) {
        opts.chained = opts.chained || true;
    }
    return function (ctx, next) {
        return __awaiter(this, void 0, void 0, function () {
            var ignore_1, path, normalizedPath, query;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!opts.defer) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, next()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        ignore_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        if (ctx.status === httpStatus_1.default.OK) {
                            return [2 /*return*/];
                        }
                        // We have already done a redirect and we will continue if we are in chained mode
                        if (opts.chained && ctx.status === httpStatus_1.default.MOVED_PERMANENTLY) {
                            path = getPath(ctx.response.get('Location'), ctx.querystring);
                        }
                        else if (ctx.status !== httpStatus_1.default.MOVED_PERMANENTLY) {
                            path = getPath(ctx.originalUrl, ctx.querystring);
                        }
                        if (path) {
                            normalizedPath = path_1.posix.normalize(path);
                            if (path !== normalizedPath) {
                                query = ctx.querystring ? "?" + ctx.querystring : '';
                                ctx.status = httpStatus_1.default.MOVED_PERMANENTLY;
                                ctx.redirect("" + normalizedPath + query);
                            }
                        }
                        if (!!opts.defer) return [3 /*break*/, 6];
                        return [4 /*yield*/, next()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
};
var getPath = function (original, querystring) {
    if (querystring) {
        return original.slice(0, -querystring.length - 1);
    }
    return original;
};
exports.default = normalizePath;
//# sourceMappingURL=koaNormalizePath.js.map